import React from 'react';
import './UpdateRow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function UpdateRow({ fieldName, newValue, currentValue, emptyText, isUpdated, isLoading, isError, reloadAction }) {
  if (logComponent('UpdateRow')) { console.debug('UpdateRow rendered'); }

  return (
    <li key={ fieldName } className="Update-Row">
      <span className="Update-Row__field-name-sm">{fieldName}
        {
          isUpdated &&
          <FontAwesomeIcon className="Update-Row__icon" icon="sync-alt" />
        }
      </span>
      <div className="Update-Row__item">
        <span className="Update-Row__field-source">CURRENT</span>
        <span className="Update-Row__field-name">{fieldName}</span>
        {
          isLoading ?
            <p className="Update-Row__loading-message">Loading...</p> :
            isError ?
              <p className="Update-Row__error-message">Unable to load data...
                <button
                  className="Update-Row__reload-item"
                  onClick={reloadAction} >
                  Try Again
                  <FontAwesomeIcon icon="redo-alt" />
                </button>
              </p> :
              currentValue ?
                <span className="Update-Row__field-value">{currentValue}</span> :
                <span className="Update-Row__empty-field">{emptyText || 'Not Provided'}</span>
        }
      </div>

      <div className="Update-Row__item">
        <span className="Update-Row__field-source">NEW</span>
        <span className="Update-Row__field-name">{fieldName}
          {
            isUpdated &&
            <FontAwesomeIcon className="Update-Row__icon" icon="sync-alt" />
          }
        </span>
        {
          isLoading ?
            <p className="Update-Row__loading-message">Loading...</p> :
            isError ?
              <p className="Update-Row__error-message">Unable to load data...</p> :
              newValue ?
                <span className="Update-Row__field-value">{newValue}</span> :
                <span className="Update-Row__empty-field">{emptyText || 'Not Provided'}</span>
        }
      </div>
    </li>
  );
}